import {
  encartPackProduitsTitreTexteLogosMock,
  listingPackProduitsMock,
  texteSeoMock,
  titreDescriptionMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreDescriptionMock(),
  encartPackProduitsTitreTexteLogosMock(),
  listingPackProduitsMock('appliances'),
  texteSeoMock(),
];

export const packElectroMock: SlugPage = {
  ...pageBase({
    title: 'Pack éléctroménager',
    type: 'pack',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
